// components/ProfileTextField.tsx
import { TextField } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledTextField = styled(TextField)(() => ({
  '& label.MuiInputLabel-outlined': {
    color: '#999',
    backgroundColor: '#000',
    padding: '0 5px',
    zIndex: 1,
  },
  '& label.Mui-focused': {
    color: '#fff',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#999',
      borderWidth: '2px',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255,255,255,0.7)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'rgba(255,255,255,0.7)',
    },
  },
  '& input': {
    color: '#fff',
    height: '56px',
    padding: '0 10px',
  },
}))
